var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.196 0.233552H4.59439C3.72548 0.233552 3.0187 0.940336 3.0187 1.80924V2.70071H2.14268C1.27378 2.70071 0.566992 3.4075 0.566992 4.2764V13.0016C0.566992 13.8705 1.27378 14.5773 2.14268 14.5773H7.74434C8.61325 14.5773 9.31997 13.8705 9.31997 13.0016V12.9205H10.196C11.0649 12.9205 11.7717 12.2137 11.7717 11.3448V1.80924C11.7717 0.940336 11.065 0.233552 10.196 0.233552ZM8.16814 13.0016C8.16814 13.2352 7.97791 13.4254 7.7444 13.4254H2.14268C1.90911 13.4254 1.71889 13.2352 1.71889 13.0016V4.27634C1.71889 4.04276 1.90911 3.85254 2.14268 3.85254H7.74434C7.9779 3.85254 8.16807 4.04275 8.16807 4.27634L8.16814 13.0016ZM10.6198 11.3448C10.6198 11.5784 10.4296 11.7686 10.196 11.7686H9.32003V4.27634C9.32003 3.40743 8.61325 2.70065 7.7444 2.70065H4.17059V1.80918C4.17059 1.5756 4.36081 1.38538 4.59439 1.38538H10.196C10.4296 1.38538 10.6198 1.5756 10.6198 1.80918V11.3448Z",
    fill: "#403F42",
    stroke: "#403F42",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3b4ee5d1e6cafe1d4911e8d76ff37e9d.svg";
export { ForwardRef as ReactComponent };